import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Lock } from 'lucide-react'
import { SkeletonZeilen } from './States'

interface Props {
  titel: string
  /** Hoehe der neutralen Vorschau, wenn keine eigene uebergeben wird. */
  zeilen?: number
  /** Unscharf gezeigte Form des gesperrten Inhalts -- nie echte Daten. */
  vorschau?: ReactNode
}

/**
 * Inhalt hinter dem Login: unscharfe Vorschau, darueber Anmelden und Registrieren.
 *
 * Seit 13.09.2026 geben die Ideen-Endpunkte ohne Anmeldung nichts heraus. Die
 * Vorschau ist deshalb immer eine Attrappe, nie ein verwischter echter Inhalt:
 * Unschaerfe im Browser allein waere keine Grenze.
 */
export default function LoginGate({ titel, zeilen = 4, vorschau }: Props) {
  return (
    <div className="q-gate">
      <div className="q-gate-teaser" aria-hidden="true">
        {vorschau ?? <SkeletonZeilen anzahl={zeilen} />}
      </div>
      <div className="q-gate-overlay">
        <Lock aria-hidden="true" />
        <span className="q-gate-title">{titel}</span>
        <div className="q-btnrow">
          <Link to="/login" className="q-btn q-btn-primary q-btn-sm">
            Anmelden
          </Link>
          <Link to="/register" className="q-btn q-btn-ghost q-btn-sm">
            Registrieren
          </Link>
        </div>
      </div>
    </div>
  )
}
